module.exports = __webpack_public_path__ + "b51e5f408daf388364264f149b0782b3.svg";